export const manageGradients: (element: Element) => [hasLeftGradient: boolean, hasRightGradient: boolean] = element => {
    const maxScroll = element.scrollWidth - element.clientWidth;
    const currentScroll = element.scrollLeft;

    // -1 because of chrome bug
    return [currentScroll > 0, currentScroll < maxScroll -1];
};